const translations = {
    manageSubscription: 'Manage Subscription',
    upgradeSubscription: 'Upgrade Subscription'
};

export default translations;
